@if (initialized) {
  <div>
    @if (!subContractors.length) {
      <div class="mat-body-strong">No sub contractors</div>
    }
    @if (subContractors.length) {
      <div class="cards-container">
        @for (sc of subContractors; track sc) {
          <div class="stroked-card">
            <div class="mat-body-strong capitalize">
              <mat-checkbox [checked]="sc.checked" [disabled]="!canAdd" (change)="onChange(sc, $event.checked)">
                {{sc.name}}
              </mat-checkbox>
            </div>
            @if (sc.address) {
              <div class="mat-caption">
                <div>{{sc.address?.line1}}</div>
                <div>{{sc.address?.line2}}</div>
                <div>{{sc.address?.city}}, {{sc.address?.region}}</div>
                <div>{{sc.address?.country}} {{sc.address?.zip}}</div>
              </div>
            }
            <div class="line">
              @if (sc.poc) {
                <div class="line">
                  <mat-icon color="primary">person</mat-icon>{{sc.poc}}
                </div>
              }
              @if (sc.poc_phone) {
                <div class="line">
                  <mat-icon color="primary">phone</mat-icon>{{sc.poc_phone}}
                </div>
              }
            </div>
          </div>
        }
        @if (initialized && pagination.length && subContractors.length) {
          <mat-paginator (page)="pageChanged($event)"
            [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
          </mat-paginator>
        }
      </div>
    }
  </div>
}
